import React, { useCallback, useEffect, useState } from "react";
import Table from "../components/Table";
import axios from "axios";
import { apiKey } from "../config/config";

export default function ItemReport({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [inventoryList, setInventoryList] = useState([]);
  const [investorList, setInvestorList] = useState([]);
  const [investor, setInvestor] = useState("");
  const [branchId, setBranchId] = useState();

  const fetchInventory = useCallback(() => {
    try {
      axios
        .get(apiKey + "/get-items", {
          params: {
            branch_id: branchId,
            investor_id: investor,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setInventoryList(res.data.result || []);
        });
    } catch (err) {
      console.error(err);
    }
  }, [branchId, investor, token]);

  const columns = [
    {
      header: lang['Inventory'] || "Inventory",
      accessorKey: "inventory_item",
    },
    {
      header: lang.Investor || "Owner",
      accessorKey: "investor_name",
    },
    {
      header: lang.category || "Category",
      accessorKey: "type",
    },
    {
      header: lang.Quantity || "Quantity",
      accessorKey: "inventory_quantity",
    },
    {
      header: lang["Total Cost Price"] || "Total Cost Price",
      cell: (row) => {
        const qty = row.row.original.inventory_quantity || 0;
        const totalDef = row.row.original.inventory_price || 0;
        return (totalDef * qty).toFixed(2);
      },
    },
    {
      header: lang["Default Unit Price"] || "Default Unit Price",
      accessorKey: "inventory_default_unit_price",
    },
    {
      header: lang["Default Total Price"] || "Default Total Price",
      cell: (row) => {
        const val = row.getValue();
        if (val !== undefined && val !== null) return Number(val).toFixed(2);
        const qty = row.row.original.inventory_quantity || 0;
        const totalDef = row.row.original.inventory_default_unit_price || 0;
        return (totalDef * qty).toFixed(2);
      },
    },
  ];

  useEffect(() => {
    if (branchId) {
      fetchInventory();
      axios
        .get(apiKey + "/investor", {
          params: {
            branch_id: branchId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setInvestorList(res.data.result || []);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [branchId, fetchInventory, token]);

  useEffect(() => {
    setBranchId(
      JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id
    );
  }, []);

  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Reports || "Reports"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">{lang.Reports || "Reports"}</li>
              <li className="breadcrumb-item active">{lang.Item || "Item"}</li>
            </ol>
          </nav>
        </div>
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="mt-3 mb-3">
                    <div className="rr">{lang.Item_List || "Item List"}</div>
                    <div className="row justify-content-end gap-2">
                      <select
                        onChange={(e) => setInvestor(e.target.value)}
                        value={investor}
                        className="form-data btn-export col-3"
                      >
                        <option value="">
                          {lang.all_investors || "All Investors"}
                        </option>
                        {investorList.map((inv, index) => (
                          <option key={index} value={inv.id}>
                            {inv.FullName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="d-flex mt-3 mb-3">
                    <Table lang={lang} data={inventoryList} columns={columns} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
